export interface IOption<T = number> {
  leasing_switch?: boolean;
  name: string;
  id: T;
  active?: boolean;
  disable_cause?: string;
  product_type?: number;
  // NOTE: вид ставки НДС, которого нет в стране проекта, но он уже выбран у записей (этап 1, F5)
  legacy?: boolean;
}
